import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get session_id from URL fragment
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

        console.log('AuthCallback: Processing session_id:', sessionId ? 'found' : 'not found');

        if (!sessionId) {
          console.error('No session_id found in URL');
          navigate('/');
          return;
        }

        // Exchange session_id for user data via our backend (to avoid CORS issues)
        const response = await axios.post(`${API_URL}/api/auth/google-callback`, {
          session_id: sessionId
        });

        const { user, token } = response.data;

        console.log('AuthCallback: Got user data:', user?.email);

        // Store in localStorage
        localStorage.setItem('user_token', token);
        localStorage.setItem('user_data', JSON.stringify({
          email: user.email,
          name: user.name,
          picture: user.picture
        }));
        localStorage.setItem('compoundr_subscribed', 'true');

        // Fetch user progress (including onboarding data) and restore to localStorage
        try {
          const userId = user.email || user.id;
          const progressRes = await axios.get(`${API_URL}/api/progress/${userId}`);
          const progress = progressRes.data;
          
          // Restore onboarding data to localStorage if completed
          if (progress.onboarding && progress.onboarding.investor_type) {
            localStorage.setItem("investorQuizCompleted", progress.onboarding.investor_type);
            localStorage.setItem("recommendedCategory", progress.onboarding.recommended_category);
            localStorage.setItem("onboardingComplete", "true");
          }
        } catch (progressError) {
          console.log("No progress data found for user");
        }

        // Clear the URL hash
        window.history.replaceState(null, '', window.location.pathname);

        // Redirect to home
        window.location.href = '/';

      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-emerald-500 mx-auto mb-4" />
        <p className="text-lg text-slate-600">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
